"use strict";

angular.module('rmCampaign')
	.factory('Campaign', require('./campaign.js'));